import { ActionType } from '../../types';

export const PxdbDeviceActions = {
    pxdbGatewayDeviceRegistrationStarted: () =>
        ({
            type: 'PxdbGatewayDevice/Registration/Started',
        } as const),

    pxdbGatewayDeviceRegistrationSucceeded: (message: string, data: {}, connectionString: string) =>
        ({
            type: 'PxdbGatewayDevice/Registration/Succeeded',
            payload: { message, data, connectionString },
        } as const),

    pxdbGatewayDeviceRegistrationFailed: (errorCode: string) =>
        ({
            type: 'PxdbGatewayDevice/Registration/Failed',
            payload: { errorCode },
        } as const),

    pxdbGatewayDeviceRegistrationUnmounted: () =>
        ({
            type: 'PxdbGatewayDevice/Registration/Unmounted',
        } as const),

    pxdbGatewayDeviceMasterData: (hasData: boolean) =>
        ({
            type: 'PxdbGatewayDevice/MasterData/Failed',
            payload: { hasData },
        } as const),
};

export type PxdbDeviceActions = ActionType<typeof PxdbDeviceActions>;
